import { render } from "./BaseNotifications.vue?vue&type=template&id=d9856622"
import script from "./BaseNotifications.vue?vue&type=script&lang=js"
export * from "./BaseNotifications.vue?vue&type=script&lang=js"

import "./BaseNotifications.vue?vue&type=style&index=0&id=d9856622&lang=css"

import exportComponent from "/usr/src/citizenm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__